/**
 * Utility function to check if the request is a GraphQL query.
 * It's based on the presence of the query property in the request data object.
 * @param config The Axios request configuration.
 * @returns {boolean} True if the request is a GraphQL query.
 */ export var isGraphQLQuery = function(config) {
    var _config_data;
    return Boolean((_config_data = config.data) == null ? void 0 : _config_data.query);
};
